import { PageJumpNav } from "@/components/page-jump-nav";
import type { ResolvedFeaturePageBlock } from "@garimpa/api/featurePages/types";

/** Feature pages use the shared "on this page" jump nav over their headed blocks. */
export function FeaturePageSectionNavigation({ blocks }: { blocks: ResolvedFeaturePageBlock[] }) {
  const items = blocks.flatMap((block) =>
    block.type !== "hero" && block.heading ? [{ id: block.id, label: block.heading }] : [],
  );

  return <PageJumpNav items={items} layout="fullBleed" />;
}
